import React, { ReactElement, ReactNode } from 'react'

export interface BottomBarProps extends React.HTMLAttributes<HTMLDivElement> {
    children: ReactNode
    alignRight?: boolean
}

export const BottomBar = ({ alignRight = false, children, ...props }: BottomBarProps): ReactElement => (
    <div
        {...props}
        className={`bottom-bar__container correct-spacing-page--x
        ${alignRight ? ' bottom-bar--align-right' : ''}
        ${props.className ? props.className : ''}`}
    >
        <hr className="bottom-bar__shadow" aria-hidden />
        <div className="bottom-bar__content-wrapper">{children}</div>
    </div>
)
